import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["inline", "title", "titleWeight", "size", "fullWidth", "scrollable", "padded", "options", "value", "selectType", "onChange", "onChipClick", "dataTestId"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { clsx } from 'clsx';
import * as styles from './Chips.module.css';
import { ChipButton } from '../../internal/ChipButton';
import { generateDataTestId } from '../../../internal/utils';

/**
 * Компонент чипсов
 *
 * [Ссылка на макеты](https://www.figma.com/design/4UM8zoowH9YGMM7fSK0rhD/%F0%9F%8C%90-Web-Components?node-id=37116-32493&m=dev)
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function ChipsComponent(_ref, ref) {
  var inline = _ref.inline,
    title = _ref.title,
    _ref$titleWeight = _ref.titleWeight,
    titleWeight = _ref$titleWeight === void 0 ? 'bold' : _ref$titleWeight,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'M' : _ref$size,
    fullWidth = _ref.fullWidth,
    scrollable = _ref.scrollable,
    _ref$padded = _ref.padded,
    padded = _ref$padded === void 0 ? true : _ref$padded,
    options = _ref.options,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? [] : _ref$value,
    _ref$selectType = _ref.selectType,
    selectType = _ref$selectType === void 0 ? 'single' : _ref$selectType,
    onChange = _ref.onChange,
    onChipClick = _ref.onChipClick,
    dataTestId = _ref.dataTestId,
    chipProps = _objectWithoutProperties(_ref, _excluded);
  var handleChange = React.useCallback(function (changedValue) {
    return function (checked, event) {
      if (selectType === 'single') {
        onChipClick === null || onChipClick === void 0 || onChipClick(changedValue, checked, event);
        onChange === null || onChange === void 0 || onChange(value.includes(changedValue) ? [] : [changedValue]);
        return;
      }
      if (selectType === 'multiple') {
        onChipClick === null || onChipClick === void 0 || onChipClick(changedValue, checked, event);
        var newValues = value.includes(changedValue) && !checked ? value.filter(function (value) {
          return value !== changedValue;
        }) : [].concat(_toConsumableArray(value), [changedValue]);
        onChange === null || onChange === void 0 || onChange(newValues);
        return;
      }
      if (selectType === 'oneOf') {
        if (changedValue === value[0]) {
          return;
        }
        onChipClick === null || onChipClick === void 0 || onChipClick(changedValue, checked, event);
        onChange === null || onChange === void 0 || onChange([changedValue]);
        return;
      }
    };
  }, [onChange, onChipClick, selectType, value]);
  var handleChipClick = React.useCallback(function (event) {
    if (scrollable) {
      event.currentTarget.scrollIntoView({
        behavior: 'smooth',
        inline: 'center',
        block: 'nearest'
      });
    }
  }, [scrollable]);
  return /*#__PURE__*/_jsxs("div", {
    className: clsx(styles['chips'], _defineProperty(_defineProperty({}, styles['chips--inline'], inline), styles['chips--fullWidth'], fullWidth)),
    ref: ref,
    children: [title && /*#__PURE__*/_jsx("span", {
      className: clsx(styles['title'], _defineProperty(_defineProperty(_defineProperty({}, styles['title--small'], size === 'S'), styles['title--medium'], size === 'M'), styles['title--bold'], titleWeight === 'bold')),
      "data-testid": generateDataTestId(dataTestId, ['title']),
      children: title
    }), /*#__PURE__*/_jsx("ul", {
      className: clsx(styles['content'], _defineProperty(_defineProperty(_defineProperty({}, styles['content--wrap'], !fullWidth && !scrollable), styles['content--scrollable'], !fullWidth && scrollable), styles['content--padded'], padded)),
      children: options.map(function (_ref2, index) {
        var label = _ref2.label,
          optionValue = _ref2.value,
          icon = _ref2.icon,
          counter = _ref2.counter,
          disabled = _ref2.disabled,
          optionDataTestId = _ref2.dataTestId,
          ref = _ref2.ref;
        return /*#__PURE__*/_jsx("li", {
          className: styles['item'],
          onClick: handleChipClick,
          ref: ref,
          children: /*#__PURE__*/_jsx(ChipButton, _objectSpread({
            text: label,
            checked: value.includes(optionValue),
            icon: icon,
            counter: counter,
            onClick: handleChange(optionValue),
            size: size,
            dataTestId: optionDataTestId || generateDataTestId(dataTestId, [String(optionValue)]),
            disabled: disabled || chipProps.disabled
          }, chipProps))
        }, index);
      })
    })]
  });
}
export var Chips = /*#__PURE__*/React.forwardRef(ChipsComponent);